import clsx from 'clsx';
import Structure from 'components/3catinfo/Structure';
import __isEmpty from 'lodash/isEmpty';
import styles from './contenidor.module.scss';

export default function Contenidor(props) {
    const { tipus, estil, className, condicio, tag = 'div', mostrarWeb = true, minHeight, minHeightByViewport } = props;
    let TagSeo = tag;
    const styleContenidor = clsx(
        'contenidor',
        styles.contenidor,
        tipus && styles[tipus],
        estil && styles[estil],
        !__isEmpty(className) && className
    );

    const getMinHeightValue = (value) => (typeof value === 'number' ? `${value}px` : value);
    const minHeightMap = minHeightByViewport || minHeight;
    const customStyle = {
        ...(typeof minHeightMap === 'object' && minHeightMap !== null
            ? Object.entries(minHeightMap).reduce((acc, [viewport, value]) => {
                  if (value !== undefined && value !== null) {
                      acc[`--contenidor-min-height-${viewport}`] = getMinHeightValue(value);
                  }
                  return acc;
              }, {})
            : {}),
        ...(typeof minHeight === 'string' || typeof minHeight === 'number'
            ? { '--contenidor-min-height': getMinHeightValue(minHeight) }
            : {})
    };

    if (condicio === '' || !mostrarWeb) return <></>;

    const getContent = () => {
        if (!__isEmpty(props?.children)) {
            return props.children;
        } else {
            return <Structure {...props} />;
        }
    };

    return (
        <TagSeo className={styleContenidor} style={customStyle}>
            {getContent()}
        </TagSeo>
    );
}
